import View from './FormFirstAccess';
import enhancer from './FormFirstAccess.enhancer';

export default enhancer(View);
